<template>
<VueSelect
  v-model="valueAccessor"
  :options="options"
  :reduce="o => o.key"
  :searchable="false"
  :clearable="false"
  class="custom-select catalog-desktop-sorting-select"
/>
</template>

<script>
import VueSelect from 'vue-select';

export default {
  components: {
    VueSelect,
  },
  props: {
    value: {
      required: true,
      type: String,
    },
    availableSortings: {
      type: Object,
    },
  },
  computed: {
    valueAccessor: {
      get() { return this.value; },
      set(v) { this.$emit('input', v); },
    },
    options() {
      return Object.entries(this.availableSortings)
        .map(([key, v]) => ({ ...v, key, }));
    },
  },
}
</script>

<style lang="less">
@import '~@/assets/less/components/forms';

.catalog-desktop-sorting-select {
  // Override styles defined in `forms.less`.
  &.v-select {
    @apply flex;
    .vs__dropdown-toggle {
      @apply py-0 flex items-center;
      min-height: unset;
    }
  }
}
</style>
